import React from 'react';
import '../../App.css';
import Footer from '../Footer';
import { Link } from 'react-router-dom';


function EPK() {
  return (
    <>

        <div class="epk-header">
            <Link to='/' className='epk-logo'>
            </Link>

            <div class="epk-socials-banner">
              <a class="epk-instagram-icon" href="https://www.instagram.com/joylared/"></a>
              <a class="epk-spotify-icon" href="https://open.spotify.com/artist/3ozsPuRX2eY5Hvgzvrfjph"></a>
              <a class="epk-linktree-icon" href="https://linktr.ee/joylared"></a>
              <a class="epk-tiktok-icon" href="https://www.tiktok.com/@joylared"></a>
              <p style={{color: '#881111', fontSize: '1.75vw', fontStyle: 'bold', translate: '0 -2.8vw'}}> JOYLARED.MUSIC@GMAIL.COM </p>
            </div>

        </div>

        <div class="epk-background-texture"> 
          <h1 class="bio-header"> BIO</h1>
          <span class="bio-description">Joyla Red's powerhouse songwriting duo Siahna Im (NBC's The Voice), and Bret Dylan deliver an attention to craft that cuts through the relentless chorus of quick trends with anthemic, soul-stirring hooks that demand a replay. The Seattle-based quintet deftly weaves 70s rock nostalgia and 90s alternative grit with Im's smokey, soulful vocals to transform stories of self-discovery, heartbreak, and friendship into danceable indie rock.  </span>
          <section class="release-section">
            <a style={{ textDecoration: 'none', color: 'inherit'}} href="https://distrokid.com/hyperfollow/joylared/into-the-fade">
              <div class="album-cover">
                {/* image here */}
                <h3 style={{paddingTop: '1vw'}}>INTO THE FADE EP</h3>
              </div>
            </a>

            <div class="release-info">
              <h2>NEW RELEASES</h2>
              <div class="songs">
                <div class="song">
                  <h4>ARE THERE NIGHTCLUBS IN HEAVEN?</h4>
                  <span>A twangy, alt-country tinged indie anthem</span>
                </div>
                <div class="song">
                  <h4>EDEN</h4>
                  <span>Heavy, grungy textures with layered arpeggios and fuzz-laden leads.</span>
                </div>
                <div class="song">
                  <h4>DOCTOR (CAN YOU FIX ME?)</h4>
                  <span>Reserved, introspective, with Bowie/Oasis-inspired weight.</span>
                </div>
                <div class="song">
                  <h4>HUMMINGBIRD</h4>
                  <span>60s inspired riffs channel Revolver-era Beatles and The Smiths.</span>
                </div>
              </div>
            </div>
          </section>

        <h1 class="shows-header"> NOTABLE SHOWS </h1>
        <p class="shows-description"> Tractor Tavern w/ Babes in Canyon 2025 <br></br>
                                      Capitol Hill Block Party 2025 <br></br>
                                      Fremont Fridays 2025 <br></br>
                                      Bite of Seattle 2025 <br></br>
                                      Fremont Fair 2025 <br></br>
                                      SAM Remix 2026 
        </p>

        <h1 class="highlights-header"> HIGHLIGHTS </h1>
        <p class="highlights-description"> Sold out two 200 cap shows in four months <br></br>
                                           Sold 1500 tickets in the band's first year <br></br>
                                           $5000 Battle of the Bands winner <br></br>
                                           EMERALD GEM podcast feature <br></br>
                                           BIG TAKEOVER radio feature <br></br>
                                           BALLARD VOX feature

        </p>

        </div>

        <div class="links-bg-container">
          <h1 class="links-header">LINKS & CONTACT</h1>
          <div class="video-links-container">
            <a class="music-videos-link" href="https://www.youtube.com/playlist?list=PL90r4PNAEtDVzq5Gvadsz62YpHaG1KDyy"> MUSIC VIDEOS</a>
            <a class="live-videos-link" href="https://www.youtube.com/watch?v=V7eC_cltNQY&list=PL90r4PNAEtDULcswnZV2u92jXBEq1tYfr"> LIVE VIDEO</a>

          </div>
          <a class="photo-links-container" href="https://drive.google.com/drive/u/1/folders/1nMTW8xB9rrdMGxHWYYl1I40g5y92icH9"></a>
          <a class="assets-links-container" href="https://drive.google.com/drive/folders/17Hyw8U-uJguXpdrbtpU0TW_lZheF24P0?usp=sharing"></a>
          
          {/* <a class="disco-header" style={{fontFamily:'LatinoGothic', textDecoration:'none'}} href="https://joyla-red.disco.ac/playlist-new/25294021?date=20251002&user_id=2939275&signature=6UGF07ZAbaBDU9a9ZbthMy8U8Qo%3A7zYOCl7a"> DISCO ARTIST PAGE</a> */}

          <p class="contact-description"> Direct all inquiries to: </p>
          <a class="disco-header" style={{fontFamily:'LatinoGothic', textDecoration:'none'}} >  <br></br> Siahna Im <br></br> </a>
          <a class="disco-header" style={{fontFamily:'LatinoGothic', textDecoration:'none'}} href="mailto:joylared.music@gmail.com"> <br></br> <br></br>joylared.music@gmail.com</a>
 
        </div>
        

          
      

    </>
  );
}

export default EPK;